import React from 'react';
import FormComponent from "../../common/FormComponent";
import Validators from "../../constants/ValidatorTypes";
import { addStoragePlace } from "../../services/storagePlace/StoragePlaceService";
import StoragePlaceForm from "../../components/forms/storagePlace/StoragePlaceForm";
import strings from "../../localization";
import Grid from '@material-ui/core/Grid';
import { Paper } from "@material-ui/core";
import { bindActionCreators } from 'redux';
import connect from "react-redux/es/connect/connect";
import * as Actions from '../../actions/Actions';
import { withSnackbar } from 'notistack';
import { withRouter } from "react-router-dom";

class AddStoragePlace extends FormComponent {

  validationList = {
    name: [{ type: Validators.REQUIRED }]
  };

  constructor(props) {
    super(props);

    this.state = {
      data: props.data ? props.data : {},
      errors: {}
    };

    this.props.changeFullScreen(false);
    this.submit = this.submit.bind(this);

  }

  submit() {
    if (!this.validate()) {
      return;
    }

    this.showDrawerLoader();

    addStoragePlace(this.transformRequest(this.state.data), this.props.cid).then(response => {
      if (!response.ok) {
        let messageKey = response.response.data.message;

        this.props.enqueueSnackbar(strings.storagePlace.messages[messageKey], { variant: "error" });

        this.handleError(messageKey);

        return;
      }
      this.props.enqueueSnackbar(strings.addStoragePlace.added, { variant: 'success' });
      this.props.onFinish(response.data);
      this.hideDrawerLoader();
    });
  }

  transformRequest(data) {
    return {
      ...data,
      userEmail: this.props.uemail,
    }
  }

  handleError(message) {
    switch (message) {
      case "STORAGE_WITH_NAME_ALREADY_EXIST":
        this.setError("name", strings.storagePlace.messages.STORAGE_WITH_NAME_ALREADY_EXIST);
        break;
      case "STORAGE_NOT_EXIST":
        this.setError("name", strings.storagePlace.messages.STORAGE_NOT_EXIST);
        break;
      case "STORAGE_CANT_BE_NULL":
        this.setError("name", strings.storagePlace.messages.STORAGE_CANT_BE_NULL);
        break;
    }
  }

  render() {

    return (
      <Grid id='page' item md={12}>

        <div className='header'>
          <h1>{strings.addStoragePlace.pageTitle}</h1>
        </div>

        <Paper className='paper'>
          <StoragePlaceForm
            onChange={this.changeData}
            onSubmit={this.submit}
            data={this.state.data}
            errors={this.state.errors}
            onCancel={this.props.onCancel} />
        </Paper>

      </Grid>
    );
  }

}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    changeFullScreen: Actions.changeFullScreen
  }, dispatch);
}

function mapStateToProps({ menuReducers, siteDataReducers }) {
  return { menu: menuReducers, siteData: siteDataReducers };
}

export default withSnackbar(withRouter(connect(mapStateToProps, mapDispatchToProps)(AddStoragePlace)));
